import { URLs } from '@Constants';
import React from 'react';
import styled from 'styled-components';
import { ButtonInverse } from '../GlobalStyles';
import { media } from '../style-utils';

export default class MobileMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  toggleMenu = () => {
    this.setState((state) => {
      return { isOpen: !state.isOpen };
    });
  };

  render() {
    const { color } = this.props;
    const menuHeight = '5.2rem';
    const menuHeightOpen = '60%';

    return (
      <MenuWrapper isOpen={this.state.isOpen}>
        <div>
          <MobileMenuToggle isOpen={this.state.isOpen} onClick={this.toggleMenu}>
            <svg width="19px" height="15px" viewBox="0 0 19 15">
              <path
                fill="#ffffff"
                d="M18.0649174,6.57172704 L11.7625695,0.382062345 C11.4999717,0.127354115 11.1583844,0 10.8167972,0 C10.4752099,0 10.1869825,0.153222283 9.97669421,0.382062345 C9.74076582,0.610902407 9.60947741,0.917357161 9.60947741,1.27354115 C9.60947741,1.60486562 9.74077632,1.93619008 9.97669421,2.16501996 L14.1260025,6.1896647 L1.2863092,6.19065806 C0.577505141,6.19065806 0,6.72595288 0,7.43832085 C0,8.15170766 0.551875593,8.68598365 1.2863092,8.68598365 L14.1517371,8.68598365 L9.9769568,12.63498 C9.74102841,12.8638201 9.60974,13.1702749 9.60974,13.5264588 C9.60974,13.8826428 9.71436948,14.1891078 9.9769568,14.4179377 C10.2128852,14.6467777 10.5544619,14.8 10.8960492,14.8 C11.2643059,14.8 11.5525333,14.6467777 11.7628216,14.4179377 L18.0651694,8.30494013 C18.0918389,8.27907197 18.1174842,8.22832899 18.1441536,8.20345419 C18.1441536,8.17758602 18.1708231,8.17758602 18.1964684,8.12684305 C18.4590662,7.79551858 18.484722,7.33684 18.3277673,6.97966265 C18.2752004,6.82644546 18.1695468,6.67422163 18.0649174,6.57172704 Z"
              />
            </svg>
          </MobileMenuToggle>

          <MobileMenuContainer color={color} isOpen={this.state.isOpen} menuHeight={menuHeight}>
            <MobileMenuLabel isOpen={this.state.isOpen} menuHeight={menuHeight} onClick={this.toggleMenu}>
              Menu
            </MobileMenuLabel>
            <Menu isOpen={this.state.isOpen} menuHeightOpen={menuHeightOpen}>
              <MenuInner>
                {/* <MenuLogo /> */}
                <MenuButtonContainer>
                  <MenuButton forwardedAs="a" href="#pricing">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Join
                    Now&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </MenuButton>
                  <SmallMenuItem>
                    <a href={URLs.login}>Or, sign in to your account</a>
                  </SmallMenuItem>
                </MenuButtonContainer>
              </MenuInner>
            </Menu>
          </MobileMenuContainer>
        </div>
      </MenuWrapper>
    );
  }
}

const MenuWrapper = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;

  z-index: 999;
  ${(props) => props.isOpen && `z-index: 9999;`}

  ${media.tabletLandscapeAndUp`
    display: none;
  `};
`;

const MobileMenuToggle = styled.div`
  z-index: 10;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;

  bottom: 0.7rem;
  right: 1.2rem;
  background: rgba(255, 255, 255, 0.18);
  border-radius: 50%;

  width: 3.7rem;
  height: 3.7rem;
  transform: rotate(-90deg) scale(1);
  transition: transform 250ms cubic-bezier(0.175, 0.885, 0.32, 1.1), width 100ms cubic-bezier(0.165, 0.84, 0.44, 1),
    height 100ms cubic-bezier(0.165, 0.84, 0.44, 1);

  ${(props) =>
    props.isOpen &&
    `
      width: 7rem;
      height: 7rem;
      transform: rotate(90deg) scale(1.8);
  `};
`;

const MobileMenuContainer = styled.div`
  z-index: 5;
  position: fixed;
  overflow: hidden;

  top: 0;
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;

  border-top-left-radius: 2.1rem;
  border-top-right-radius: 2.1rem;
  color: #ffffff;
  background: ${(props) => props.color || '#121212'};
  box-shadow: 0 0 4rem 0 rgba(0, 0, 0, 0.35);

  transform: translateY(100%) translateY(-${(props) => props.menuHeight});
  transition: transform 250ms cubic-bezier(0.175, 0.885, 0.1, 1.03);

  ${(props) =>
    props.isOpen &&
    `
      transform: translateY(40%);
      transition: transform 500ms cubic-bezier(0.19, 1, 0.22, 1);
  `};
`;

const MobileMenuLabel = styled.div`
  z-index: 10;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;

  line-height: ${(props) => props.menuHeight};
  font-size: 1.8rem;
  font-weight: 500;
  letter-spacing: 0.45rem;
  text-transform: uppercase;
  text-align: center;

  opacity: 1;
  transition: opacity 100ms cubic-bezier(0.785, 0.135, 0.15, 0.86);

  ${(props) =>
    props.isOpen &&
    `
    opacity: 0;
  `};
`;

const SmallMenuItem = styled('li')`
  display: block;
  padding: 0 1.5rem;
  font-size: 1.6rem;
  font-weight: 300;
  letter-spacing: -0.05rem;
  margin-bottom: 1em;
  margin-top: 1.5rem;
  line-height: 1em;

  a {
    display: inline-block;
    padding: 0.5rem;
    color: rgba(255, 255, 255, 0.5);
  }
`;

const MenuButton = styled(ButtonInverse)`
  min-width: 200px;
`;

const Menu = styled.nav`
  padding: 0 2rem;
  max-height: ${(props) => props.menuHeightOpen};
  opacity: 0;
  flex: 1 1 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  a {
    text-decoration: none !important;
  }

  ${(props) =>
    props.isOpen &&
    `
      opacity: 1;
    `};
`;

const MenuInner = styled.div`
  display: block;
`;

const MenuButtonContainer = styled.div`
  margin-top: 2rem;
`;



// WEBPACK FOOTER //
// ./src/components/MobileMenu/MobileMenu.js